import React from 'react';
import PropTypes from 'prop-types';
import ProfileHeader from '@components/ProfileHeader';

const ByName = (props) => (
    <div className="mt-4">
        <ProfileHeader />
    </div>
);

ByName.propTypes = {
    description: PropTypes.string,
};

ByName.defaultProps = {
    description: 'Driving Sales',
};

export default ByName;
